import ActiveService from  '@/service.active';

const API_URL = process.env.API_URL || 'http://localhost:3000';

class usersService extends ActiveService{
  /**
   *
   * @param $injector
   * @param $translates
   * @param $auth
   */
  constructor(
    $injector,
    $translates,
    $auth
  ){
    'ngInject';
    super($injector);
    this.$translates  = $translates;
    this.$auth        = $auth;
    this.userRoles         = [];
    this.getRoles();
  }

  /**
   *
   * @param id
   * @returns {Function}
   */
  retrieve( id ){
    return this.activeGet( `${this.getUri()}/${id}` )
      .then( (user) => {
        user.uris.Avatar = `${user.uris.Avatar}?timestamp=${Number(new Date())}`;
        return user;
      } );
  }

  /**
   *
   * @param user
   * @returns {*}
   */
  create( user ){
    return this.activePost( `${this.getUri()}`, user )
      .then( () => this.notify.set(this.$translates.get('USER_CREATE_SUCCESS'), 'success'))
      .catch( (err) => this.notify.set(err.data.reason, 'error'));
  }

  /**
   *
   * @param user
   * @returns {*}
   */
  update( user ){
    return this.activePut( `${user.uri}`, user )
      .then( () => this.$auth.me() )
      .then( () => this.notify.set(this.$translates.get('USERS_UPDATE_SUCCESS'), 'success'))
  }

  getRoles() {
    return this.activeGet(`/api/user-roles`)
      .then(data => this.userRoles = data);
  }

  getRoleByCode(code) {
    return this.userRoles.find(role => role.code === code);
  }

}

export default usersService;


/** WEBPACK FOOTER **
 ** ./frontend/components/admin/users/users.service.js
 **/